export default __webpack_public_path__ + "static/media/rewards-cards.8b051da6.png";